import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const SITE_ACCESS_KEY = "odismap_site_access";

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("odismap_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  const siteToken = localStorage.getItem(SITE_ACCESS_KEY);
  if (siteToken) config.headers["X-Site-Access"] = siteToken;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401) {
      const code = err.response?.data?.code;
      if (code === "SITE_ACCESS_REQUIRED") {
        localStorage.removeItem(SITE_ACCESS_KEY);
        if (window.location.pathname !== "/__beta") {
          window.location.reload();
        }
      } else {
        localStorage.removeItem("odismap_token");
        localStorage.removeItem("odismap_user");
      }
    }
    return Promise.reject(err);
  }
);
